import { render, staticRenderFns } from "./banner_moblie.vue?vue&type=template&id=fe9aa2f2&scoped=true"
import script from "./banner_moblie.vue?vue&type=script&lang=js"
export * from "./banner_moblie.vue?vue&type=script&lang=js"
import style0 from "./banner_moblie.vue?vue&type=style&index=0&id=fe9aa2f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe9aa2f2",
  null
  
)

export default component.exports